module.exports = __webpack_public_path__ + "img/box-open.0543b198.png";